/* CHOZEN Search pilot: search field + grouped suggestions (brands, categories, products).
   Categories and brands are matched locally from the data the theme renders from the real navigation and brand records.
   Products come from the store's own search (sections/chozen-search-suggest.liquid), debounced, with stale responses dropped.
   If anything fails the field is still a plain GET form to the search page. No credentials, no third-party calls.
   2026-11-02: suggestions start from the first letter; more categories (8), brands (6) and products (8) are shown.
   2026-11-02: below 1000px the header icon is left alone (original theme search dialog opens, like the live site).
   2026-11-03: Hebrew brand names (e.g. אדידס) are recognised through the ALIAS table below (edit it to add brands / spellings);
   exact brand-name matches are ranked first; Hebrew spellings are matched ignoring the letters ו and י.
   2026-11-03: result order is brands, then categories, then products. */
(function () {
  'use strict';
  if (window.__chozenSearch) return;
  window.__chozenSearch = true;

  var DESK = window.matchMedia('(min-width:1440px)');
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var DATA = { cats: [], brands: [], home: [] };
  var cache = {}, cacheKeys = [];
  var insts = [];
  var sheet = null, sheetInst = null, lastTrigger = null;

  /* Hebrew spellings per brand (key = Latin brand name, lower case, punctuation removed) */
  var ALIAS = {
    'adidas': ['אדידס'], 'mam': ['מאם'], 'longchamp': ['לונגשמפ', 'לונגשאמפ', 'לונשאן'],
    'desigual': ['דסיגואל', 'דיסיגואל'], 'bimba y lola': ['בימבה אי לולה', 'בימבה ולולה', 'בימבה'],
    'clarins': ['קלרינס'], 'tous': ['טואס', 'טוס'], 'ugg': ['אג', 'אוג'], 'converse': ['קונברס'],
    'birkenstock': ['בירקנשטוק', 'בירקנסטוק'], 'asics': ['אסיקס'],
    'new balance': ['ניו באלאנס', 'ניו בלאנס', 'ניובלנס'], 'vagabond': ['ואגאבונד', 'וגבונד'],
    'brownie': ['בראוני'], 'dr martens': ['דר מרטינס', 'דוקטור מרטינס', 'מרטינס'],
    'on cloud': ['און קלאוד', 'און'], 'on': ['און'], 'elizabeth arden': ['אליזבת ארדן'],
    'vans': ['ואנס'], 'bvlgari': ['בולגרי'], 'allsaints': ['אולסיינטס', 'אול סיינטס'],
    'tkees': ['טיקיז'], 'veja': ['וז׳ה', 'וגה', 'ויגה'], 'puma': ['פומה'], 'skechers': ['סקצרס', 'סקצ׳רס'],
    'nivea': ['ניוואה', 'ניווא'], 'nivea men': ['ניוואה מן', 'ניוואה גברים'], 'elemis': ['אלמיס'],
    'polo ralph lauren': ['ראלף לורן', 'פולו ראלף לורן', 'פולו'], 'reef': ['ריף'], 'timberland': ['טימברלנד'],
    'clean beauty': ['קלין ביוטי'], 'native': ['נייטיב'], 'scotch soda': ['סקוץ סודה', 'סקוטש סודה'],
    'melissa': ['מליסה'], 'clarks': ['קלארקס', 'קלרקס'], 'ferragamo': ['פרגמו', 'סלבטורה פרגמו'],
    'superdry': ['סופרדריי', 'סופר דריי'], 'el ganso': ['אל גנסו'],
    'the north face': ['נורת פייס', 'נורת׳ פייס', 'דה נורת פייס'], 'hunter': ['האנטר'],
    'cristiano ronaldo': ['כריסטיאנו רונאלדו', 'רונאלדו', 'cr7'],
    'levis': ['ליוויס', 'לויס', 'ליבייס'], 'palladium': ['פלדיום'], 'columbia': ['קולומביה'],
    'zaxy': ['זקסי'], 'crocs': ['קרוקס'], 'dickies': ['דיקיז'], 'nike': ['נייק', 'נייקי'],
    'calvin klein': ['קלווין קליין', 'קלבין קליין'], 'tommy hilfiger': ['טומי הילפיגר', 'טומי'],
    'guess': ['גס', 'גאס'], 'hoka': ['הוקה'], 'herschel': ['הרשל'], 'kanken': ['קנקן'], 'labello': ['לאבלו'],
    'jeanne en provence': ['ז׳אן אן פרובנס', 'ז׳אן אן פרובאנס']
  };

  function $(s, r) { return (r || document).querySelector(s); }
  function $$(s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD')
      .replace(/[̀-֑ͯ-ׇ]/g, '')
      .replace(/[׳״'"’`]/g, '')
      .replace(/[^\p{L}\p{N}]+/gu, ' ').trim();
  }
  /* Hebrew spelling variants: ignore the letters ו and י */
  function hstrip(s) { return s.replace(/[וי]/g, ''); }

  function loadData() {
    var el = document.getElementById('chozen-search-data'), raw;
    if (!el) return;
    try { raw = JSON.parse(el.textContent); } catch (e) { return; }
    var seen = {};
    (raw.cats || []).forEach(function (c) {
      if (!c.t || !c.u || seen[c.u]) return;
      seen[c.u] = 1;
      var parent = c.g ? c.c + ' · ' + c.g : (c.c || 'קטגוריה');
      DATA.cats.push({ t: c.t, u: c.u, p: parent, nt: norm(c.t), h: norm(c.t + ' ' + (c.c || '') + ' ' + (c.g || '')) });
      if (c.m) DATA.home.push({ t: c.t, u: c.u });
    });
    var bs = {};
    (raw.brands || []).forEach(function (b) {
      if (!b.n || !b.u || bs[b.n]) return;
      bs[b.n] = 1;
      var n = norm(b.n), al = (ALIAS[n] || []).map(norm);
      DATA.brands.push({ t: b.n, u: b.u, i: b.i, s: parseFloat(b.s) || 1, x: parseFloat(b.x) || 0, y: parseFloat(b.y) || 0, nt: n, al: al, h: [n].concat(al).join(' ') });
    });
  }

  function match(list, nq, limit) {
    var tk = nq.split(' '), out = [], heb = /[֐-׿]/.test(nq), nqs = heb ? hstrip(nq) : nq;
    list.forEach(function (x, idx) {
      var ok = true, i, t, ts;
      for (i = 0; i < tk.length; i++) {
        t = tk[i];
        if (x.h.indexOf(t) < 0 && x.h.replace(/ /g, '').indexOf(t) < 0) {
          if (heb) {
            if (x.hs === undefined) x.hs = hstrip(x.h);
            ts = hstrip(t);
            if (ts && (x.hs.indexOf(ts) > -1 || x.hs.replace(/ /g, '').indexOf(ts) > -1)) continue;
          }
          ok = false; break;
        }
      }
      if (!ok) return;
      var score = null, a, an, k;
      if (x.nt === nq) score = -1;
      else if (x.nt.indexOf(nq) === 0) score = 0;
      if (x.al && score !== -1) {
        for (k = 0; k < x.al.length; k++) {
          a = x.al[k]; an = heb ? hstrip(a) : a;
          if (a === nq || an === nqs) { score = -1; break; }
          if ((a.indexOf(nq) === 0 || an.indexOf(nqs) === 0) && (score === null || score > 0)) score = 0;
        }
      }
      if (score === null) score = (' ' + x.nt).indexOf(' ' + tk[0]) > -1 ? 1 : x.nt.indexOf(tk[0]) > -1 ? 2 : 3;
      out.push({ x: x, s: score, i: idx });
    });
    out.sort(function (a, b) { return a.s - b.s || a.i - b.i; });
    return out.slice(0, limit).map(function (o) { return o.x; });
  }

  var CHEV = '<svg class="cs-chev" viewBox="0 0 7 12" width="7" height="12" aria-hidden="true" focusable="false"><path d="M6 1 1 6l5 5" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function Inst(root) {
    var mode = root.getAttribute('data-mode'), uid = root.getAttribute('data-uid');
    var input = $('.cs-input', root), clear = $('.cs-clear', root), panel = $('.cs-panel', root), status = $('.cs-status', root), form = $('form', root);
    var cur = -1, seq = 0, timer = null, ctrl = null, prod = { state: 'idle', list: [] }, isOpen = false, n = 0;
    var self = { root: root, mode: mode, input: input, close: close, open: open, render: render, reset: reset };

    function opts() { return $$('.cs-opt', panel); }
    function searchUrl(q) { return (form.getAttribute('action') || '/search') + '?q=' + encodeURIComponent(q); }

    function opt(href, cls, inner) {
      return '<a role="option" id="' + uid + '-o' + (n++) + '" tabindex="-1" class="cs-opt ' + cls + '" href="' + esc(href) + '" aria-selected="false">' + inner + '</a>';
    }
    function group(k, label, body) {
      return '<div class="cs-group" role="group" aria-labelledby="' + uid + '-g' + k + '"><h3 class="cs-h" id="' + uid + '-g' + k + '">' + label + '</h3>' + body + '</div>';
    }
    function catRow(c) { return opt(c.u, 'cs-cat', '<span class="cs-t">' + esc(c.t) + '</span><span class="cs-p">' + esc(c.p) + '</span>'); }
    function brandRow(b) {
      var img = b.i ? '<img src="' + esc(b.i) + '" alt="" loading="lazy" width="66" height="30" style="--cl-s:' + b.s + ';--cl-x:' + b.x + ';--cl-y:' + b.y + '">' : '';
      return opt(b.u, 'cs-brand', '<span class="cs-logo">' + img + '</span><span class="cs-bn">' + esc(b.t) + '</span>');
    }
    function prodRow(p) {
      var img = p.i ? '<img class="cs-pimg" src="' + esc(p.i) + '" alt="" loading="lazy" width="44" height="44">' : '<span class="cs-pimg cs-pimg--empty"></span>';
      var price = '<span class="cs-price">' + (p.c ? '<s>' + esc(p.c) + '</s> ' : '') + '<b>' + esc(p.p) + '</b>' + (p.a === false ? ' <em>אזל</em>' : '') + '</span>';
      return opt(p.u, 'cs-prod', img + '<span class="cs-ptxt"><span class="cs-pt">' + esc(p.t) + '</span>' + (p.v ? '<span class="cs-pv">' + esc(p.v) + '</span>' : '') + '</span>' + price);
    }
    function chip(c) { return opt(c.u, 'cs-chip', esc(c.t)); }

    function render() {
      var q = input.value.trim(), nq = norm(q), h = '', prevHref = null, total = 0;
      var a = opts()[cur]; if (a) prevHref = a.getAttribute('href');
      n = 0;
      if (!nq) {
        if (DATA.home.length) h += group('home', 'גלו לפי קטגוריה', '<div class="cs-chips">' + DATA.home.map(chip).join('') + '</div>');
        h += group('br', 'מותגים', opt('/pages/brands', 'cs-more', '<span>לכל המותגים</span>' + CHEV));
        panel.innerHTML = h;
        setStatus('');
      } else {
        var cats = match(DATA.cats, nq, 8), brs = match(DATA.brands, nq, 6), plist = prod.state === 'ok' ? prod.list : [];
        if (brs.length) h += group('b', 'מותגים', brs.map(brandRow).join(''));
        if (cats.length) h += group('c', 'קטגוריות', cats.map(catRow).join(''));
        if (prod.state === 'loading') {
          h += group('p', 'מוצרים', '<div class="cs-skel" aria-hidden="true"><i></i><i></i><i></i></div><p class="cs-msg">מחפשים מוצרים…</p>');
        } else if (prod.state === 'ok' && plist.length) {
          h += group('p', 'מוצרים', plist.map(prodRow).join(''));
        } else if (prod.state === 'err') {
          h += group('p', 'מוצרים', '<p class="cs-msg cs-msg--err">לא ניתן לטעון הצעות מוצרים כרגע. אפשר להמשיך: Enter או הקישור למטה פותחים את כל תוצאות החיפוש.</p>');
        }
        var settled = prod.state !== 'loading';
        total = cats.length + brs.length + plist.length;
        if (settled && !total) {
          h += '<div class="cs-empty"><p class="cs-empty__t">לא נמצאו הצעות עבור “' + esc(q) + '”</p><p class="cs-msg">נסו שם קטגוריה, מותג או סוג מוצר, או עברו לכל תוצאות החיפוש. אפשר גם לבחור קטגוריה:</p>' +
            (DATA.home.length ? '<div class="cs-chips">' + DATA.home.map(chip).join('') + '</div>' : '') + '</div>';
        }
        h += '<div class="cs-foot">' + opt(searchUrl(q), 'cs-all', '<span>לכל תוצאות החיפוש</span><span class="cs-q" dir="auto">“' + esc(q) + '”</span>' + CHEV) + '</div>';
        panel.innerHTML = h;
        if (settled) setStatus(total ? 'נמצאו ' + total + ' הצעות' : 'לא נמצאו הצעות');
      }
      cur = -1;
      if (prevHref) { opts().some(function (o, i) { if (o.getAttribute('href') === prevHref) { cur = i; return true; } }); }
      mark(cur, false);
    }
    function setStatus(t) { if (status.textContent !== t) status.textContent = t; }
    function mark(i, scroll) {
      var list = opts();
      list.forEach(function (o, j) { o.setAttribute('aria-selected', String(j === i)); });
      cur = i;
      if (i > -1 && list[i]) {
        input.setAttribute('aria-activedescendant', list[i].id);
        if (scroll !== false) list[i].scrollIntoView({ block: 'nearest' });
      } else input.removeAttribute('aria-activedescendant');
    }

    function open() {
      if (window.chozenMega) window.chozenMega.close(false);
      insts.forEach(function (o) { if (o !== self && o.mode === 'inline') o.close(); });
      render();
      panel.hidden = false; isOpen = true;
      input.setAttribute('aria-expanded', 'true');
    }
    function close() {
      if (mode === 'sheet') return;
      if (!isOpen && panel.hidden) return;
      panel.hidden = true; isOpen = false; cur = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }
    function reset() {
      input.value = ''; clear.hidden = true; cancel(); prod = { state: 'idle', list: [] };
    }
    function cancel() { clearTimeout(timer); if (ctrl) { ctrl.abort(); ctrl = null; } seq++; }

    function schedule() {
      cancel();
      var q = input.value.trim(), key = norm(q);
      if (key.length < 1) { prod = { state: 'idle', list: [] }; return; }
      if (cache[key]) { prod = { state: 'ok', list: cache[key] }; return; }
      prod = { state: 'loading', list: [] };
      var my = seq;
      timer = setTimeout(function () { fetchProducts(q, key, my); }, 150);
    }
    function fetchProducts(q, key, my) {
      var url = ROOT + 'search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&section_id=chozen-search-suggest';
      ctrl = ('AbortController' in window) ? new AbortController() : null;
      fetch(url, { credentials: 'same-origin', signal: ctrl ? ctrl.signal : undefined })
        .then(function (r) { if (!r.ok) throw new Error('http ' + r.status); return r.text(); })
        .then(function (t) {
          if (my !== seq) return;
          var s = new DOMParser().parseFromString(t, 'text/html').querySelector('script[data-chozen-search-results]');
          var list = s ? JSON.parse(s.textContent) : [];
          if (!Array.isArray(list)) throw new Error('bad data');
          if (cacheKeys.length > 60) delete cache[cacheKeys.shift()];
          cache[key] = list; cacheKeys.push(key);
          prod = { state: 'ok', list: list };
          if (mode === 'sheet' || isOpen) render();
        })
        .catch(function (e) {
          if ((e && e.name === 'AbortError') || my !== seq) return;
          prod = { state: 'err', list: [] };
          if (mode === 'sheet' || isOpen) render();
        });
    }

    input.addEventListener('focus', function () { if (mode === 'inline') open(); });
    input.addEventListener('input', function () {
      clear.hidden = !input.value;
      schedule();
      if (mode === 'inline') open(); else render();
    });
    input.addEventListener('keydown', function (e) {
      var list = opts(), k = e.key;
      if (k === 'ArrowDown') {
        e.preventDefault();
        if (mode === 'inline' && !isOpen) { open(); return; }
        if (list.length) mark(cur >= list.length - 1 ? 0 : cur + 1);
      } else if (k === 'ArrowUp') {
        e.preventDefault();
        if (list.length) mark(cur <= 0 ? list.length - 1 : cur - 1);
      } else if (k === 'Enter') {
        if (cur > -1 && list[cur]) { e.preventDefault(); window.location.assign(list[cur].href); }
        else if (!input.value.trim()) e.preventDefault();
      } else if (k === 'Escape') {
        if (mode === 'sheet') { e.preventDefault(); e.stopPropagation(); closeSheet(true); }
        else if (isOpen) { e.preventDefault(); e.stopPropagation(); close(); }
      }
    });
    form.addEventListener('submit', function (e) { if (!input.value.trim()) e.preventDefault(); });
    clear.addEventListener('click', function () {
      input.value = ''; clear.hidden = true; cancel(); prod = { state: 'idle', list: [] };
      input.focus();
      if (mode === 'inline') open(); else render();
    });
    panel.addEventListener('mousedown', function (e) { e.preventDefault(); });
    panel.addEventListener('error', function (e) {
      var t = e.target; if (!t || t.tagName !== 'IMG') return;
      if (t.classList.contains('cs-pimg')) { var sp = document.createElement('span'); sp.className = 'cs-pimg cs-pimg--empty'; t.replaceWith(sp); }
      else { var row = t.closest('.cs-brand'); t.remove(); if (row) row.classList.add('cs-brand--nologo'); }
    }, true);
    root.addEventListener('focusout', function (e) {
      if (mode === 'inline' && !root.contains(e.relatedTarget)) close();
    });
    if (mode === 'sheet') {
      $('[data-chozen-search-close]', root).addEventListener('click', function () { closeSheet(true); });
    }
    insts.push(self);
    return self;
  }

  function vv() {
    var v = window.visualViewport, st = document.documentElement.style;
    st.setProperty('--cs-vvh', (v ? v.height : window.innerHeight) + 'px');
    st.setProperty('--cs-vvtop', (v ? v.offsetTop : 0) + 'px');
  }
  function openSheet(trigger) {
    if (!sheet || !sheetInst) return;
    lastTrigger = trigger || null;
    if (window.chozenMega) window.chozenMega.close(false);
    insts.forEach(function (o) { if (o.mode === 'inline') o.close(); });
    sheet.hidden = false;
    document.documentElement.classList.add('cs-lock');
    if (trigger) trigger.setAttribute('aria-expanded', 'true');
    vv();
    sheetInst.render();
    sheetInst.root.querySelector('.cs-panel').hidden = false;
    sheetInst.input.setAttribute('aria-expanded', 'true');
    setTimeout(function () { sheetInst.input.focus(); }, 30);
  }
  function closeSheet(restore) {
    if (!sheet || sheet.hidden) return;
    sheet.hidden = true;
    document.documentElement.classList.remove('cs-lock');
    sheetInst.input.setAttribute('aria-expanded', 'false');
    sheetInst.reset();
    var t = lastTrigger; lastTrigger = null;
    if (t) { t.setAttribute('aria-expanded', 'false'); if (restore) t.focus(); }
  }

  function init() {
    loadData();
    $$('[data-chozen-search]').forEach(function (r) { if (!r.__cs) { r.__cs = true; var i = Inst(r); if (r.getAttribute('data-mode') === 'sheet') sheetInst = i; } });
    sheet = $('[data-chozen-search-sheet]');
    if (sheet && sheet.parentNode !== document.body) document.body.appendChild(sheet);
    if (sheetInst) { sheetInst.root.querySelector('.cs-panel').hidden = true; }

    /* header icon opens the sheet between 1000px and the desktop breakpoint; below 1000px the original dialog is used */
    window.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-chozen-search-open]');
      if (!a || DESK.matches || window.innerWidth < 1000) return;
      e.preventDefault(); e.stopImmediatePropagation();
      openSheet(a);
    }, true);

    if (sheet) {
      sheet.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') { e.preventDefault(); e.stopPropagation(); closeSheet(true); return; }
        if (e.key !== 'Tab') return;
        var f = $$('input, button', sheet).filter(function (el) { return !el.hidden && !el.disabled && el.getClientRects().length; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      });
    }
    if (window.visualViewport) { window.visualViewport.addEventListener('resize', vv); window.visualViewport.addEventListener('scroll', vv); }
    window.addEventListener('resize', function () { if (sheet && !sheet.hidden) vv(); });
    if (sheet) sheet.addEventListener('click', function (e) { if (e.target === sheet) closeSheet(true); });
    var onDesk = function () { if (DESK.matches) closeSheet(false); };
    if (DESK.addEventListener) DESK.addEventListener('change', onDesk); else DESK.addListener(onDesk);

    if (window.MutationObserver) {
      var mo = new MutationObserver(function (m) {
        if (m.some(function (x) { return x.target.hidden === false; })) insts.forEach(function (o) { if (o.mode === 'inline') o.close(); });
      });
      $$('[data-chozen-mega]').forEach(function (el) { mo.observe(el, { attributes: true, attributeFilter: ['hidden'] }); });
    }
    document.addEventListener('shopify:section:unload', function () { closeSheet(false); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
